export const ROLES_TO_DELETE_TEAM = ['ADMIN' as const];
